import $ from 'jquery';
import debounce from 'lodash.debounce';

export const init = () => {
	const jsSatisfactionYes = $('.js-satisfaction-yes');
	const jsSatisfactionNo = $('.js-satisfaction-no');
	const jsSatisfactionSend = $('.js-satisfaction-send');

	const jsSatisfactionComplete = $('.js-satisfaction-complete');
	const jsSatisfactionInner = $('.js-satisfaction-inner');

	const jsSatisfactionArea = $('.js-satisfaction-area');
	const jsSatisfactionTextArea = $('#satisfactionTextArea');
	const jsSatisfactionText = $('.js-satisfaction-text');
	const jsSatisfactionAreaError = $('.js-satisfaction-error');

	// YES button class
	const jsApi = $('.js-api').data('url');

	// SEND button class
	const jsApi1 = $('.js-api-1').data('url');

	// TOKEN
	const token = document.getElementById('RequestVerificationToken');

	let textAreaVal;

	function onFocus(event) {
		if (event.target === document.activeElement) {
			event.target.parentElement.classList.add('has-focus');
		}
	}

	function onFocusOut(event) {
		event.target.parentElement.classList.remove('has-focus');
	}

	function sendDataLayer(answer) {
		dataLayer.push({
			event: 'feedbackSubmit',
			feedbackAnswer: answer,
		});
	}

	jsSatisfactionYes.on('click', function (e) {
		e.preventDefault();

		let request = null;
		request = $.ajax({
			type: 'POST',
			url: jsApi,
			contentType: 'application/json',
			beforeSend: function (req) {
				req.setRequestHeader(token.name, token.value);
			},
			success: function (res) {
				jsSatisfactionInner.toggleClass('is-hidden');
				jsSatisfactionComplete.toggleClass('is-active');
				sendDataLayer('yes');
			},
			error: function (err) {
				if (err.status === '404') return;
				console.error('There seems to be an error with the API');
			},
		});
	});

	jsSatisfactionNo.on('click', function (e) {
		e.preventDefault();

		jsSatisfactionInner.toggleClass('is-hidden');
		jsSatisfactionArea.toggleClass('is-active');
		jsSatisfactionTextArea.on('focus', onFocus);
		jsSatisfactionTextArea.on('focusout', onFocusOut);
		sendDataLayer('no');
	});

	jsSatisfactionTextArea.on(
		'keyup',
		debounce(function () {
			// https://stackoverflow.com/questions/16471730/preventing-a-form-from-submitting-when-filled-with-new-lines-only
			if ($.trim($(this).val()).length < 1) {
				textAreaVal = false;
			} else {
				textAreaVal = $(this).val();
			}

			if (!!textAreaVal) {
				jsSatisfactionText.removeClass('has-error');
				jsSatisfactionAreaError.removeClass('is-active');
			} else {
				jsSatisfactionText.addClass('has-error');
				jsSatisfactionAreaError.addClass('is-active');
			}
		}, 300),
	);

	jsSatisfactionSend.on('click', function (e) {
		e.preventDefault();

		/**
		 * data prop in req - textAreaValue
		 */

		if (!!textAreaVal) {
			let request = null;

			request = $.ajax({
				type: 'POST',
				url: jsApi1,
				contentType: 'application/json',
				data: JSON.stringify(textAreaVal),
				beforeSend: function (req) {
					req.setRequestHeader(token.name, token.value);
				},
				success: function (res) {
					jsSatisfactionTextArea.val('');
					jsSatisfactionArea.toggleClass('is-active');
					jsSatisfactionComplete.toggleClass('is-active');
				},
				error: function (err) {
					if (err.status === '404') return;
					console.error('There seems to be an error with the API');
				},
			});
		} else {
			jsSatisfactionText.addClass('has-error');
			jsSatisfactionAreaError.addClass('is-active');
			console.error("Satisfaction text can't be empty or have empty line breaks");
		}
	});
};
